import type { IButtonStyles } from '@fluentui/react';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { ActionControlId } from 'owa-ribbon-ids';
import loc from 'owa-localize';
import { fluidText } from '../../utils/actionControlStrings.locstring.json';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';
import type { MenuDefinition } from '@1js/acui-menu/lib/components/MenuDefinition';
import { createAppFlyoutAnchor } from 'owa-command-ribbon';
import Loop from 'owa-fluent-mobile-brand-icons-svg/lib/icons/IcFluentLoopColor';

export const getFluidHero = computedFn(
    (
        editorId: string,
        menuDefinition: MenuDefinition,
        styles: IButtonStyles | undefined,
        isDisabled: boolean
    ): RibbonControlProps => {
        return createAppFlyoutAnchor(
            getComposeRibbonId(ActionControlId.Fluid, editorId),
            loc(fluidText),
            menuDefinition,
            undefined /* keytipProps */,
            Loop,
            undefined /*iconColors*/,
            styles,
            {
                disabled: isDisabled,
            }
        );
    }
);
